import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Box from '../Box';
import Button from '../Button';
import { parseColor } from '../system';
var SUPPORTS_CSS_STICKY = typeof window !== 'undefined' && window.CSS && window.CSS.supports;

function NavigationArrow(_ref) {
  var _outerProps, _innerProps, _objectSpread2;

  var direction = _ref.direction,
      headerHeight = _ref.headerHeight,
      offsets = _ref.offsets,
      progress = _ref.progress,
      mouseTouchHandlers = _ref.mouseTouchHandlers;
  var colorBase = parseColor({
    base: 'grey-0',
    alpha: 0
  });
  var color = parseColor('grey-0');
  var side = direction === -1 ? 'left' : 'right';
  var outerProps = (_outerProps = {
    'aria-hidden': true,
    position: SUPPORTS_CSS_STICKY ? 'sticky' : 'absolute',
    top: 0
  }, _outerProps[side] = offsets[side] + 'px', _outerProps.zIndex = 25, _outerProps.width = 0, _outerProps.css = {
    '@media print': {
      display: 'none'
    }
  }, _outerProps);
  var innerProps = (_innerProps = {
    position: 'absolute',
    top: 0
  }, _innerProps[side] = 0, _innerProps.height = headerHeight + 'px', _innerProps.transition = 'all 300ms ease', _innerProps);

  var buttonProps = _objectSpread((_objectSpread2 = {
    icon: {
      name: "caret-" + side
    },
    title: "navigate " + side,
    theme: false,
    disabled: direction === 1 ? progress >= 0.99 : progress <= 0,
    height: '100%'
  }, _objectSpread2[direction === -1 ? 'paddingLeft' : 'paddingRight'] = 1, _objectSpread2[direction === -1 ? 'paddingRight' : 'paddingLeft'] = 2, _objectSpread2), mouseTouchHandlers(direction));

  var translateY = SUPPORTS_CSS_STICKY ? -100 : 0;

  if (direction === 1) {
    innerProps.opacity = progress >= 0.99 || progress === null ? 0 : 1;
    innerProps.transform = "translate(" + (progress >= 0.99 ? 100 : 0) + "%, " + translateY + "%)";
    innerProps.background = "linear-gradient(-90deg, " + color + " 24px, " + colorBase + ")";
  } else {
    innerProps.opacity = progress <= 0 ? 0 : 1;
    innerProps.transform = "translate(" + (progress <= 0 ? -100 : 0) + "%, " + translateY + "%)";
    innerProps.background = "linear-gradient(90deg, " + color + " 24px, " + colorBase + ")";
  }

  return /*#__PURE__*/React.createElement(Box, outerProps, /*#__PURE__*/React.createElement(Box, innerProps, /*#__PURE__*/React.createElement(Button, buttonProps)));
}

export default NavigationArrow;